export default __webpack_public_path__ + "static/media/icon-list-pricing.3779935d.svg";